module.exports = __webpack_public_path__ + "media/images/top/pap/common/hero-3e7a1fb714fbf0b3b692406eb6fa3d19.png";